/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const CheckFilled24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Check Filled 24">
      <circle cx={12} cy={12} r={10} fill="#94B200" className="Fill-Main" />
      <path
        className="Details"
        fill="#fff"
        fillRule="evenodd"
        d="M17.783 8.216a.712.712 0 0 1-.006 1.028l-6.825 6.546a.767.767 0 0 1-1.054 0l-3.675-3.525a.712.712 0 0 1-.006-1.028.767.767 0 0 1 1.06-.006l3.148 3.019 6.298-6.04a.767.767 0 0 1 1.06.006Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
const CheckFilled64 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 64 64"
    {...props}
  >
    <g className="Check filled 64" clipPath="url(#a)">
      <circle cx={32} cy={32} r={32} fill="#94B200" className="Fill-Main" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M46.476 22.54a1.822 1.822 0 0 1-.014 2.57L29.968 41.476c-.706.7-1.843.7-2.549 0l-8.881-8.812a1.822 1.822 0 0 1-.014-2.57 1.808 1.808 0 0 1 2.563-.015l7.607 7.547 15.219-15.1c.712-.706 1.86-.7 2.563.015Z"
        className="Details"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a" className="a">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);

const SIZE_MAP = {
  sm: CheckFilled24,
  md: CheckFilled24,
  lg: CheckFilled24,
  xl: CheckFilled24,
  xxl: CheckFilled64,
  xxxl: CheckFilled64,
};

export const CheckFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'check-filled-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
